package org.moxultimate.topwithmox.apps.data

import kotlinx.serialization.Serializable

/**
 * AppsTypeResponse
 * Maps the backend AppsTypeEntity returned by GET /apps-type.
 */
@Serializable
data class AppsTypeResponse(
    val id: Long,
    val type: String? = null,
)
